<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary mb-0">
            <b-card-body class="px-lg-5 py-lg-5">

              <div v-if="!enviado">
                <h4 class="text-center mb-3">{{ $t('recuperar_contrasena') }}</h4>
                <p class="text-muted text-center mb-4" style="font-size:14px;">
                  {{ $t('recuperar_contrasena_desc') }}
                </p>

                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <p class="p-login">{{ $t('correo_electronico') }}</p>
                    <b-form-input
                      alternative
                      class="mb-3"
                      name="Email"
                      :rules="{ required: true, email: true }"
                      :state="fieldState"
                      prepend-icon="ni ni-email-83"
                      :placeholder="$t('placeholder_correo')"
                      v-model="email"
                      @input="fieldState = null"
                    ></b-form-input>
                    <b-form-invalid-feedback v-if="errorMsg">
                      <h3 class="text-center mb-2">
                        <b-badge variant="danger">{{ errorMsg }}</b-badge>
                      </h3>
                    </b-form-invalid-feedback>

                    <div class="text-center">
                      <base-button type="primary" native-type="submit" class="my-4" :disabled="loading">
                        <span v-if="loading">{{ $t('enviando') }}</span>
                        <span v-else>{{ $t('enviar_enlace') }}</span>
                      </base-button>
                    </div>

                    <div class="text-center mt-2">
                      <a :href="ecommerceUrl" class="text-black d-block">
                        <small>{{ $t('volver_login') }}</small>
                      </a>
                    </div>
                  </b-form>
                </validation-observer>
              </div>

              <div v-else class="text-center py-3">
                <i class="ni ni-check-bold text-success" style="font-size:48px;"></i>
                <h4 class="mt-3 mb-2">{{ $t('revisa_tu_correo') }}</h4>
                <p class="text-muted" style="font-size:14px;">
                  {{ $t('revisa_tu_correo_desc', { email: email }) }}
                </p>
                <a :href="ecommerceUrl" class="text-black d-block mt-3">
                  <small>{{ $t('volver_login') }}</small>
                </a>
              </div>

            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import authService from '@/api/authService';

export default {
  data() {
    return {
      email: '',
      loading: false,
      enviado: false,
      fieldState: null,
      errorMsg: ''
    };
  },
  created() {
    // El translator no es reactivo: forzamos el idioma desde ?lang antes de renderizar.
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && ['es', 'en'].includes(urlLang)) {
      this.$setLanguage(urlLang);
      this.$forceUpdate();
    }
  },
  computed: {
    ecommerceUrl() {
      return process.env.VUE_APP_ECOMMERCE_URL || 'https://ecommerce.inexlink.com';
    }
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true;
        this.errorMsg = '';
        await authService.requestPasswordReset(this.email);
        this.enviado = true;
      } catch (error) {
        this.fieldState = false;
        this.errorMsg = error.message || this.$t('error_solicitud');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.p-login {
  margin-bottom: 0;
}
</style>
